import { Controller } from 'stimulus'
import { jsRequest } from '@react/helpers/fetch'

export default class extends Controller {
  check() {
    const box = this.element
    const url = new URL(box.dataset.route, window.location.origin)
    url.searchParams.set('completed', box.checked)

    box.disabled = true
    jsRequest(url.toString(), {
      method:    'PATCH',
      callback:  () => box.disabled = false,
      onFailure: () => {
        box.checked  = !box.checked
        box.disabled = false
      }
    })
  }
}
